
import { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
}

const defaultColors = [
  '#DC2626', '#EA580C', '#CA8A04', '#16A34A', 
  '#0891B2', '#2563EB', '#7C3AED', '#C026D3'
];

export const ColorPicker = ({ value, onChange, label = "Cor" }: ColorPickerProps) => {
  const [customColor, setCustomColor] = useState(value);

  // Sincronizar customColor quando value mudar (ex: seleção de cor predefinida)
  useEffect(() => {
    setCustomColor(value);
  }, [value]);

  const handlePredefinedColorClick = (color: string) => {
    onChange(color);
    setCustomColor(color);
  };

  const handleCustomColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setCustomColor(newColor);
    onChange(newColor);
  };

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">{label}</Label>
      
      {/* Cores predefinidas com botões redondos */}
      <div className="flex flex-wrap gap-2">
        {defaultColors.map((color) => (
          <button
            key={color}
            type="button"
            className={`w-8 h-8 rounded-full border-2 transition-all hover:scale-110 ${
              value === color ? 'border-primary scale-110 ring-2 ring-primary/20' : 'border-border'
            }`}
            style={{ backgroundColor: color }}
            onClick={() => handlePredefinedColorClick(color)}
          />
        ))}
      </div>

      {/* Seletor de cor customizada */}
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">Escolher cor personalizada</Label>
        <div className="flex gap-2 items-center">
          <Input
            type="color"
            value={customColor}
            onChange={handleCustomColorChange}
            className="w-12 h-8 p-0 border rounded-xl cursor-pointer"
          />
          <Input
            type="text"
            placeholder="#000000"
            value={customColor}
            onChange={handleCustomColorChange}
            className="flex-1 text-xs"
            pattern="^#[0-9A-Fa-f]{6}$"
          />
        </div>
      </div>
    </div>
  );
};
